import { env } from '@/env';

export function getAssetQrUrl(qrCodeValue: string): string {
  return `${env.VITE_FORMS_URL}/qr/${qrCodeValue}`;
}
